import { Injectable } from "@angular/core";
import {

  map,
} from "rxjs/operators";
import { Observable, of } from "rxjs";
import { User } from "../models/user.model";
import { environment } from "@environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { selectActiveUser, selectLoggedInUserRoles } from "@store/selectors/user/user.selectors";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private store: Store) {}

  getUserDetailsByEmail(email: string) {
    let params = new HttpParams().set("emailAddress", email);
    return this.http.get<User>(`${this.apiUrl}/Users/email`, {
      params: params,
    });
  }

  getUserRoles(): Observable<string[]> {
    return this.store.select(selectLoggedInUserRoles);
  }

  hasRequiredRoles(requiredRoles: string[]): Observable<boolean> {
    if (!requiredRoles || requiredRoles.length === 0) {
      return new Observable((observer) => {
        observer.next(true);
        observer.complete();
      });
    }

    return this.getUserRoles().pipe(
      map((userRoles) => {
        return requiredRoles.some((role) => userRoles.includes(role));
      })
    );
  }

  hasAllRequiredRoles(requiredRoles: string[]): Observable<boolean> {
    return this.getUserRoles().pipe(
      map((userRoles) => {
        return requiredRoles.every((role) => userRoles.includes(role));
      })
    );
  }

  getCurrentUser(): Observable<any> {
  return this.store.select(selectActiveUser);
}

}
